import { ResolveFn } from '@angular/router';
import { UsersHttpService } from '../../state/users/users-http.service';
import { inject } from '@angular/core';
import { UserModel } from '../../models/user/user.model';
import { assert } from '../../assert/assert';
import { AuthService } from '../../../auth/auth.service';

export const userResolver: ResolveFn<UserModel> = (route, state) => {
  const usersHttpService = inject(UsersHttpService);
  const authService = inject(AuthService);

  let userId = +state.url.split('/').pop();
  // If user id was not passed via URI, load current user from auth service.
  if (!userId) {
    userId = authService.getLoggedInUserClone().id;
  }

  assert(typeof userId !== 'undefined', 'User id is invalid.');
  return usersHttpService.getUser(userId);
};
